import type { CompanyInput, UnitInput } from '@crm/shared';
import { apiClient } from '@/lib/api-client';
import { COMPANY_ENDPOINTS } from '../constants';
import type { Company, CompanyHourDay, MonthlyGoal, MonthlyGoalInput, Unit } from '../types';

/** Chamadas HTTP da empresa (tenant) e das unidades. */
export const companyService = {
  me() {
    return apiClient.get<Company>(COMPANY_ENDPOINTS.ME);
  },

  update(input: Partial<CompanyInput>) {
    return apiClient.patch<Company>(COMPANY_ENDPOINTS.ME, input);
  },

  listUnits() {
    return apiClient.get<{ data: Unit[] }>(COMPANY_ENDPOINTS.UNITS);
  },

  createUnit(input: UnitInput) {
    return apiClient.post<Unit>(COMPANY_ENDPOINTS.UNITS, input);
  },

  updateUnit(id: string, input: Partial<UnitInput>) {
    return apiClient.patch<Unit>(COMPANY_ENDPOINTS.unit(id), input);
  },

  /** Liga o WhatsApp da unidade a um numero; vazio desconecta. */
  connectWhatsapp(id: string, phone: string) {
    return apiClient.put<Unit>(`${COMPANY_ENDPOINTS.unit(id)}/whatsapp`, { phone });
  },

  /**
   * Liga a conta Twilio da propria empresa. O registro do remetente acontece
   * no painel dela; aqui so confirmamos que existe e guardamos a credencial.
   */
  linkWhatsappAccount(id: string, input: { accountSid: string; authToken: string; phone: string }) {
    return apiClient.post<Unit>(`${COMPANY_ENDPOINTS.unit(id)}/whatsapp/account`, input);
  },

  /** Reconsulta o estado do numero em quem entrega a mensagem. */
  refreshWhatsapp(id: string) {
    return apiClient.post<Unit>(`${COMPANY_ENDPOINTS.unit(id)}/whatsapp/refresh`, {});
  },

  removeUnit(id: string) {
    return apiClient.delete<{ message: string }>(COMPANY_ENDPOINTS.unit(id));
  },
  /** Metas do mes corrente. A API cria a partir do mes anterior se faltar. */
  goals() {
    return apiClient.get<MonthlyGoal>(COMPANY_ENDPOINTS.GOALS);
  },

  saveGoals(input: MonthlyGoalInput) {
    return apiClient.put<MonthlyGoal>(COMPANY_ENDPOINTS.GOALS, input);
  },

  hours() {
    return apiClient.get<{ data: CompanyHourDay[] }>(COMPANY_ENDPOINTS.HOURS);
  },

  saveHours(days: CompanyHourDay[]) {
    return apiClient.put<{ data: CompanyHourDay[] }>(COMPANY_ENDPOINTS.HOURS, { days });
  },
};
